<div class="row margin-0">

  <div class="col-md-12 padding-left-0 padding-right-0 margin-bottom-5 landing-nav-sticky">
    <div class="hpanel">

      <div class="mainNav panel-body border-radius-top-left-right-6">
        <div class="navIteam" *ngIf="allConnect">
          <h6 class="fw-bold">All Business Networks : <span> {{count||0}}</span></h6>
        </div>
        <div class="navIteam" *ngIf=" connect">
          <h6 class="fw-bold">Active Contacts : <span> {{count||0}}</span></h6>
        </div>
        <div class="navIteam" *ngIf="requestrecived">
          <h6 class="fw-bold">Requests Received : <span> {{count||0}}</span></h6>
        </div>
        <div class="navIteam" *ngIf="requestsent">
          <h6 class="fw-bold">Requests Sent : <span> {{count||0}}</span></h6>
        </div>

        <div class="navIteam pos-rel-10">
          <input #txt (input)="keyupdata(txt.value)" type="text" class="form-control input-sm pd-lt-10 search-field-pad"
            placeholder="Search Business Network" aria-label="Amount (to the nearest dollar)"
            [(ngModel)]="searchContent" name="searchadmin" id="searchadmin" />
          <ng-icon name="tablerSearch" class="pos-rel-25"></ng-icon>
        </div>
        <div class="navIteam connectionbtn">
          <div *ngIf="membershipType=='Growth'||membershipType=='Starter'||membershipType=='ScaleX'" class="btn-group unified-btn" dropdown
            [container]="'body'" placement="bottom right">

            <!-- Single combined button -->
            <button type="button" class="btn primary-btn filter-single-btn" dropdownToggle data-toggle="dropdown">

              <span>{{ btnnameshow }}</span>
              <ng-icon name="tablerFilter"></ng-icon>

            </button>

            <!-- Dropdown options -->
            <ul class="dropdown-menu no-padding dropdown-menu-right leftview" *dropdownMenu role="menu">

              <li role="menuitem">
                <a class="dropdown-item" [class.selected]="status === null" (click)="filterstatus(null)">
                  All
                </a>
              </li>

              <li role="menuitem">
                <a class="dropdown-item" [class.selected]="status === 'CONNECTED'" (click)="filterstatus('CONNECTED')">
                  Active Contacts
                </a>
              </li>

              <li role="menuitem">
                <a class="dropdown-item" [class.selected]="status === 'REQUEST_RECEIVED'" (click)="filterstatus('REQUEST_RECEIVED')">
                  Requests Received
                </a>
              </li>

              <li role="menuitem">
                <a class="dropdown-item" [class.selected]="status === 'REQUEST_SENT'" (click)="filterstatus('REQUEST_SENT')">
                  Requests Sent
                </a>
              </li>

            </ul>
        
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- //Business Network -->
  <div *ngIf="membershipType=='Growth'||membershipType=='Starter'||membershipType=='ScaleX'"
    class="col-sm-75 col-md-75 col-lg-75 padding-left-0 padding-right-0">
    <ng-container *ngIf="(connectionlistuserdata | async)?.length > 0">
      <div class="col-md-6 col-lg-3 padding-left-0 padding-right-5"
        *ngFor="let data of (connectionlistuserdata | async) | customFilter:{userName: searchKey}: false">
        <app-b2bnetwork-card [businessDetails]="businessDetails"
          (updateNetworkList)="refreshBusinessNetworkList($event)" [BusinessDataInput]="data"></app-b2bnetwork-card>
      </div>
    </ng-container>
    <ng-container *ngIf="loadAPIcall">
      <div class="col-md-6 col-lg-3 padding-left-0 padding-right-5" style="margin-bottom: 5px;"
        *ngFor="let n of [1, 2, 3, 4, 5, 6, 7, 8]">
        <app-common-skeleton [NameOftheScreen]="'networkcard'"></app-common-skeleton>
      </div>
    </ng-container>

    <app-nodata-found [title]="noDatafound" *ngIf="showNoDatafound"></app-nodata-found>
  </div>
  <div *ngIf="membershipType=='Free'||membershipType=='Pro'"
    class="col-sm-75 col-md-75 col-lg-75 padding-left-0 padding-right-0">
    <app-upgrade-message [Page]="page">
    </app-upgrade-message>
  </div>

  <div class="col-sm-25 col-md-25 col-lg-25 padding-right-0 landing-sticky-widget">
    <div class="">
      <app-common-widget [page]="'NETWORK_PAGE'" [inputData]="'NETWORK'" [userType]="'ALL'"></app-common-widget>
    </div>
  </div>
  <div class="col-sm-8 gs-end-of-list" *ngIf="stopScroll && (connectionlistuserdata | async)?.length > 0"
    style="text-align: center; padding-top: 1rem;">
    <div class="col-sm-12">
      <!-- <ng-icon name="tablerCircleCheck" class="end-of-list-icon"></ng-icon> -->
      <ng-icon name="tablerCircleCheck"></ng-icon>

    </div>
    <div class="col-sm-12">
      <p class="biase">You've reached the bottom of the page</p>
    </div>
  </div>

</div>
<div infiniteScroll [infiniteScrollDistance]="1" [infiniteScrollThrottle]="1000" (scrolled)="onScrollDown()"></div>